var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 13.1429H6.11358L13.5848 5.67162C13.5949 5.76066 13.6 5.85117 13.6 5.94287C13.6 6.24787 13.5425 6.54037 13.44 6.80787C14.9 7.10287 16 8.39537 16 9.94287C16 11.7104 14.5675 13.1429 12.8 13.1429ZM9.8675 3.94787C10.1525 3.75663 10.4825 3.62444 10.8374 3.5703L1.76646 12.6413C0.709115 12.014 0 10.8609 0 9.54287C0 7.97287 1.005 6.63787 2.405 6.14537C2.4025 6.07787 2.4 6.01037 2.4 5.94287C2.4 3.73287 4.19 1.94287 6.4 1.94287C7.8825 1.94287 9.175 2.74787 9.8675 3.94787ZM14.0728 1.95106L1.95095 14.0729L2.75907 14.881L14.8809 2.75919L14.0728 1.95106Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOff);
export default __webpack_public_path__ + "static/media/cloud_off.f2b45758eae7da3e251abd1f2e65b7bf.svg";
export { ForwardRef as ReactComponent };